import BaseService from '@/network/base-service'

class PacienteService extends BaseService {
  constructor () {
    super(`${process.env.VUE_APP_API_BASE_URL}/paciente`)
  }
  getPaciente (idPaciente) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/${idPaciente}`, {
      headers: {
        credentials: 'same-origin',
        withCredentials: true
      }
    })
  }
  atualizarPaciente (payload) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente`, {
      method: 'PUT',
      body: JSON.stringify(payload),
      headers: {
        credentials: 'same-origin',
        withCredentials: true,
        'Content-Type': 'application/json'
      }
    })
  }
  atualizarAvatar (codigo) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/atualizaravatar/${codigo}`, {
      method: 'POST'
    })
  }
  getSolicitacoesDocumentos (params) {
    if (Object.keys(params).length <= 1) {
      return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/documentossolicitacoes?tipo=${params.type}`, { method: 'GET' })
    } else {
      return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/documentossolicitacoes?tipo=${params.type}&dataInicio=${params.initDate}&dataFim=${params.endDate}`, { method: 'GET' })
    }
  }
  proximosAgendamentos (quantidade) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/proximosagendamentos?n=${quantidade}`, {
      method: 'GET'
    })
  }
  documentosRecentes (quantidade) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/documentosrecentes?n=${quantidade}`, {
      method: 'GET'
    })
  }
  getFinalidades (tipo) {
    return this.get(`paciente/documentossolicitacoes/finalidades/${tipo}`)
  }
  getRacaCor() {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/racaCor`, {
      method: 'GET'
    })
  }
  getEtnias() {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/etnias`, {
      method: 'GET'
    })
  }
  atualizarDadosPessoais (payload) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/dadospessoais`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
      headers: {
        credentials: 'same-origin',
        withCredentials: true,
        'Content-Type': 'application/json'
      }
    })
  }
  atualizarContato (payload) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/contato`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
      headers: {
        credentials: 'same-origin',
        withCredentials: true,
        'Content-Type': 'application/json'
      }
    })
  }
  atualizarEndereco (payload) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/endereco`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
      headers: {
        credentials: 'same-origin',
        withCredentials: true,
        'Content-Type': 'application/json'
      }
    })
  }
  getExisteAceiteTelerradiologia() {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/ExisteAceiteTelerradiologia`, {
      method: 'GET'
    })
  }
  incluirAceiteTelerradiologia () {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/IncluirAceiteTelerradiologia`, {
      method: 'POST'
    })
  }
}

export default new PacienteService()
